<template>
  <div class="w-full h-full bg-white border border-grey-200 rounded">
    <div class="w-full h-full flex flex-col">
      <div class="border-solid border-grey-200 border-b p-4 relative">
        <p class="text-base text-gray-500 flex flex-row items-center font-bold">
          {{ title }}
        </p>
      </div>
      <div
        class="
          w-full
          my-4
          px-4
          dashboard-chart-area
          flex flex-col
          justify-center
        "
      >
        <div class="w-full h-full flex flex-row justify-end rounded">
          <span
            class="
              border-solid border
              first
              text-sm
              py-1
              px-2
              hover:text-pink
              cursor-pointer
              hover:border-pink
            "
            v-for="(day, index) in days"
            :key="index"
            :class="{
              'text-pink border-pink': day.days == activeItem,
              'text-grey-500 border-grey-200': day.days != activeItem,
            }"
            @click="refreshReport(day.days)"
          >
            {{ day.name }}
          </span>
        </div>
        <div class="w-full h-full" v-if="dataLoaded">
          <div
            class="w-full justify-center"
            style="height: 350px"
            v-if="hasUsed == 0"
          >
            <div
              class="w-full flex flex-col justify-center items-center h-full"
            >
              <h4 class="text-xl font-bold mb-3">
                {{ $t('frontend_gd_dashboard_get_started_with') }} {{ title }}
              </h4>
              <p class="text-sm w-1/2 text-center mb-4">
                {{ $t('frontend_gd_dashboard_get_no_data_to') }} {{ title }}
                {{ $t('frontend_gd_dashboard_get_today') }}.
              </p>
              <gd-button primary class="h-10 w-32" @click="linkRedirect">
                {{ $t('frontend_gd_dashboard_get_started') }}
              </gd-button>
            </div>
          </div>
          <div
            class="w-full justify-center items-center"
            style="height: 350px"
            v-else-if="hasData == 0"
          >
            <div
              class="w-full flex flex-col justify-center items-center h-full"
              style="height: 350px"
            >
              <img src="../assets/emptyinsights.png" />
              <p class="text-sm w-1/2 text-center mb-4 mt-4">
                {{ $t('frontend_gd_dashboard_nodata_to_show') }}
              </p>
            </div>
          </div>
          <div v-else>
            <div
              class="
                w-full
                flex flex-row
                items-center
                justify-between
                mt-2
                mb-2
              "
              v-if="stats"
            >
              <div
                class="flex flex-col"
                v-for="(stat, index) in stats"
                :key="index"
              >
                <h4 class="text-3xl text-color font-bold">
                  {{ stat.stat }}
                </h4>
                <span class="text-sm text-gray-100">
                  {{ stat.name }}
                </span>
              </div>
            </div>
            <vue-apex-charts
              ref="realtimeChart"
              type="bar"
              height="300"
              :options="chartOptions"
              :series="chartSeries"
              class="w-full"
            ></vue-apex-charts>
          </div>
        </div>
        <div v-else>
          <ContentLoader viewBox="0 0 180 400" style="height: 350px">
            <rect x="10" y="78" rx="0" ry="0" width="15" height="50"></rect>
            <rect x="30" y="53" rx="0" ry="0" width="15" height="75"></rect>
            <rect x="50" y="68" rx="0" ry="0" width="15" height="60"></rect>
            <rect x="70" y="48" rx="0" ry="0" width="15" height="80"></rect>
            <rect x="90" y="53" rx="0" ry="0" width="15" height="75"></rect>
            <rect x="110" y="58" rx="0" ry="0" width="15" height="70"></rect>
            <rect x="130" y="68" rx="0" ry="0" width="15" height="60"></rect>
            <rect x="150" y="48" rx="0" ry="0" width="15" height="80"></rect>
          </ContentLoader>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import VueApexCharts from 'vue-apexcharts';
import { ContentLoader } from 'vue-content-loader';

export default {
  middleware: 'auth',
  components: {
    apexchart: VueApexCharts,
    ContentLoader,
  },
  props: {
    title: {
      required: true,
    },
    data: {
      required: true,
    },
  },
  data() {
    return {
      days: [
        { days: 0, name: this.$t('frontend_gd_dashboard_today') },
        { days: 7, name: this.$t('frontend_gd_dashboard_7days') },
        { days: 14, name: this.$t('frontend_gd_dashboard_14days') },
        { days: 30, name: this.$t('frontend_gd_dashboard_month') },
      ],
      chartOptions: {
        chart: {
          height: 350,
          type: 'bar',
          zoom: {
            enabled: false,
          },
        },
        dataLabels: {
          enabled: false,
        },
        plotOptions: {
          bar: {
            horizontal: false,
            startingShape: 'flat',
            endingShape: 'flat',
          },
        },
        title: {
          text: '',
          align: 'left',
        },
        grid: {
          row: {
            colors: ['transparent', 'transparent'],
            opacity: 0.5,
          },
          strokeDashArray: 8,
        },
        xaxis: {
          categories: [],
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          crosshairs: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
        yaxis: {
          show: false,
          showAlways: false,
          labels: {
            show: false,
          },
          axisBorder: {
            show: false,
          },
          crosshairs: {
            show: false,
          },
          tooltip: {
            enabled: false,
          },
        },
      },
    };
  },
  computed: {
    chartSeries() {
      return this.data.data;
    },

    stats() {
      return this.data.stats;
    },

    activeItem() {
      return this.data.noOfDays;
    },

    hasUsed() {
      return this.data.hasUsed;
    },

    hasData() {
      return this.data.hasData;
    },

    dataLoaded() {
      return this.data.isLoaded;
    },
  },
  async created() {
    await this.updateSeriesLine();
  },
  async mounted() {},
  methods: {
    // for chart data
    updateSeriesLine() {
      if (this.hasUsed && this.hasData) {
        this.$nextTick(() => {
          this.$refs.realtimeChart.updateSeries(
            [
              {
                data: this.chartSeries[0].data,
              },
            ],
            false,
            true
          );
        });
      }
    },

    refreshReport(number) {
      this.$emit('refresh', number);
    },

    linkRedirect() {
      this.$emit('redirect');
    },

    numberSystem(num, decimals) {
      if (decimals == 0) {
        return parseInt(num).toLocaleString();
      }

      return parseInt(num)
        .toFixed(decimals)
        .replace(/\d(?=(\d{3})+\.)/g, '$&,');
    },
  },
};
</script>

<style>
.dashboard-chart-area .apexcharts-tooltip-marker,
.dashboard-chart-area .apexcharts-tooltip-title,
.dashboard-chart-area .apexcharts-tooltip.light {
  background: #fd6481 !important;
}
.dashboard-chart-area .apexcharts-menu-item,
.dashboard-chart-area .apexcharts-zoom-icon {
  color: #fd6481 !important;
}
.dashboard-chart-area .apexcharts-bar-area {
  fill: #fd6481 !important;
}
.dashboard-chart-area .apexcharts-line {
  stroke: #fd6481 !important;
}
.chartBox.errBox {
  height: calc(100vh - 275px);
}

.sellChart.errBox {
  height: calc(100vh - 285px);
}
</style>
